// Libs
import React, { Component } from 'react'
import Calendar from 'react-calendar'
// CSS
import "./styles.scss"
import { formatDate } from '../../../../constants/others'
// Env
import env from '../../../../env'

class SpCasePageMoreInfosSection extends Component {
  state = {
    editable: this.props.editable,
    disabled: true,
    calendarVisible: false
  }

  handleAction = (e) => {
    const { handleSave } = this.props
    const { disabled } = this.state

    if (!disabled) {
      handleSave()
      this.handleCalendar(false)
    }

    this.setState({ disabled: !disabled })
  }

  handleCalendar = (bool) => {
    this.setState({ calendarVisible: bool })
  }

  render() {
    const { title, link, options, handleChange, calendar, betaTag } = this.props
    const { editable, editingField, disabled } = this.state
    const { handleAction, handleCalendar } = this

    return (
      <div className="sp-case-page-more-infos-section">
        <div className="sp-case-page-more-infos-section__header">
          <p className="sp-case-page-more-infos-section__title">
            {title}
            {betaTag && <span className="sp-case-page-more-infos-section__beta">BETA</span>}
          </p>
          {editable &&
            <p className={disabled ? "sp-case-page-more-infos-section__action" : "sp-case-page-more-infos-section__action sp-case-page-more-infos-section__action--submit"}
              onClick={handleAction}>
              {disabled ? 'editar' : 'salvar'}
            </p>
          }
          {title === 'Informações Gerais' && link &&
            <form
              ref="tjForm"
              method='POST'
              action={link}
              target='_blank'>
              <button
                type='submit'
                className='sp-case-page-more-infos-section__action'>
                consultar tj
              </button>
            </form>
          }
        </div>
        {options.map((option, index) => {
          const { name, value, link, wrap, editable, field, normalize, calendar } = option
          const { disabled, editingField, calendarVisible } = this.state

          if (value || editable) {
            return (
              <div
                key={index}
                className={
                  wrap ?
                    'sp-case-page-more-infos-section__option sp-case-page-more-infos-section__option--wrap' :
                    (calendar && calendarVisible) ?
                      'sp-case-page-more-infos-section__option sp-case-page-more-infos-section__option--calendar'
                      :
                      'sp-case-page-more-infos-section__option'
                }>
                <p className={editable ? "sp-case-page-more-infos-section__name sp-case-page-more-infos-section__name--centered" : "sp-case-page-more-infos-section__name"}>{name}:</p>
                {!editable &&
                  <p
                    className={link ? 'sp-case-page-more-infos-section__value sp-case-page-more-infos-section__value--link' : 'sp-case-page-more-infos-section__value'}
                    onClick={() => {
                      if (link) {
                        this.refs['tjForm'].submit()
                      }
                    }}>
                    {value}
                  </p>
                }
                {editable &&
                  (calendar ?
                    (!calendarVisible) ?
                      <input
                        disabled={disabled ? true : false}
                        className={disabled ? 'sp-case-page-more-infos-section__input--disabled' : 'sp-case-page-more-infos-section__input'}
                        value={formatDate(value, false)}
                        onClick={() => handleCalendar(true)} />
                      :
                      <Calendar
                        onChange={(value) => { handleChange(field, normalize ? normalize(value) : value) }}
                        value={value ? new Date(value) : ''}
                        className='sp-case-page-more-infos-section__calendar'
                        minDate={new Date()}
                      />
                    :
                    <input
                      disabled={disabled ? true : false}
                      className={disabled ? 'sp-case-page-more-infos-section__input--disabled' : 'sp-case-page-more-infos-section__input'}
                      value={value}
                      onChange={(e) => handleChange(field, normalize ? normalize(e.target.value) : e.target.value)} />)
                }
              </div>
            )
          }
        })}
      </div>
    )
  }
}

export default SpCasePageMoreInfosSection
